import React, { Component, Fragment } from 'react';
import ResponsiveTable from 'Components/ResponsiveTable';
import Moment from 'moment';
import { getUser, getDashboardActiveView } from 'Utils/storage';
import { formatToINR } from 'Utils/transform';
import Classname  from 'classnames';

class DisposalProductSeekerBids extends Component {
    constructor() {
        super();
        this.state = {
            tripDetails: [],
            subTripDetails: []
        }
    }

    checkAllBidsSelected = () => {
        const { selectedBids, trips } = this.props;
        let sflag = true;
        (trips || []).map(trip => {
            (trip.bids || []).map(bid => {
                const findBid = (selectedBids || []).find(sBid => sBid.id === bid.id);
                if(!findBid) {
                    sflag = false;
                }
            })
        });
        return sflag;
    }

    toggleAllTrips = (e) => {
        const { trips } = this.props;
        const bids = [];
        if(e.target.checked) {
            (trips || []).map(trip => {(trip.bids || []).map(bid => {
                bid.tripId = bid.tripId;
                bids.push(bid);
            })})
        }
        this.props.setBids(bids);
    }

    toggleTrip = (e, trip) => {
        const { selectedBids } = this.props;
        (trip.bids || []).map(bid => {
            const findBidIndex = (selectedBids || []).findIndex(sBid => sBid.id === bid.id);
            if(e.target.checked) {
                if(findBidIndex == -1) {
                    bid.tripId = bid.tripId;
                    selectedBids.push(bid);
                }
            } else {
                if(findBidIndex > -1) {
                    selectedBids.splice(findBidIndex, 1);
                }
            }
        });
        this.props.setBids(selectedBids)
    }

    checkTripAllBid = (trip) => {
        const { selectedBids } = this.props;
        let sFlag = true;
        (trip.bids || []).map(bid => {
            const findBidIndex = (selectedBids || []).findIndex(sBid => sBid.id === bid.id);
            if(findBidIndex === -1) {
                sFlag = false;
            }
        });
        return sFlag;
    }

    toggleBid = (e, bid) => {
        const { selectedBids } = this.props;
        if(e.target.checked) {
            bid.tripId = bid.tripId;
            selectedBids.push(bid);
        } else {
            selectedBids.splice((selectedBids || []).findIndex(sBid => sBid.id === bid.id), 1)
        }
        this.props.setBids(selectedBids);
    }

    checkOrderTextBid = (orderText) => {
        const { trips, selectedBids } = this.props;
        const sBid = (selectedBids || []).filter(bid => bid.orderText === orderText);
        const tripBids = [];
        (trips || []).map(trip => {
            const findBid = (trip.bids || []).find(bid => bid.orderText === orderText);
            if(findBid) {
                tripBids.push(findBid);
            }
        });
        return selectedBids.length > 0 && sBid.length === tripBids.length;
    }

    toggleOrderText = (e, orderText) => {
        const { trips, selectedBids } = this.props;
        (trips || []).map(trip => {
            const findtripBid = (trip.bids || []).find(bid => bid.orderText === orderText);
            if(findtripBid) {
                const findSBidIndex = (selectedBids || []).findIndex(bid => bid.id === findtripBid.id);
                if(e.target.checked) {
                    if(findSBidIndex === -1) {
                        selectedBids.push(findtripBid);
                    }
                } else {
                    selectedBids.splice(findSBidIndex, 1);
                }
            }
        });
        this.props.setBids(selectedBids);
    }

    render() {
        const { trips, rfq, systemTime, selectedBids } = this.props;
        const { tripDetails, subTripDetails } = this.state;
        const dashboardActiveView = this.props.dashboardActiveView ? this.props.dashboardActiveView : getDashboardActiveView();
        const isApproveOfLoi = (dashboardActiveView === 10);
        const isApproveMessage = (dashboardActiveView === 10) || (dashboardActiveView === 12);
        let maxBids = [];
        (rfq.trips || []).map(trip => {
            if(trip.bids.length > maxBids.length) {
                maxBids = trip.bids;
            }
        });
        const isDepotWise = (((rfq || {}).rfqDetails || {}).disposalContractType !== 2);
        return (
            <div className="box-shadow col-1 pv-10 ph-5 mt-20">
                 <ResponsiveTable className="courier-table pt-10 ph-10 pb-80">
                    <table cellpadding="0" cellspacing="0" className="col-1">
                        <thead>
                           <tr>
                               <th>
                                {(rfq.rfqDetails.biddingEnd < systemTime) && 
                                <input 
                                    type="checkbox" 
                                    checked={selectedBids.length > 0 && this.checkAllBidsSelected()}
                                    onClick={(e) => this.toggleAllTrips(e)} 
                                />}
                                Sl No.
                                </th>
                               <th>Zone</th>
                               {isDepotWise && <>
                                <th>Depot Code</th>
                                <th>Depot Name</th>
                               </>}
                               <th>Price</th>
                               <th>Lifting Date</th>
                               {rfq && (maxBids || []).map(bid => {
                                return <th width="250">{(rfq.rfqDetails.biddingEnd < systemTime) && 
                                    <input 
                                        type="checkbox" 
                                        checked={selectedBids.length > 0 && this.checkOrderTextBid(bid.orderText)}
                                        onClick={(e) => this.toggleOrderText(e, bid.orderText)} 
                                    />}{bid.orderText}</th>
                               })}
                            </tr>
                        </thead>
                        <tbody>
                            {(rfq.trips || []).map((trip, valIndex) => {
                            return(<>
                                <tr style={{'backgroundColor': '#d4f2ff'}}>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>
                                        {(rfq.rfqDetails.biddingEnd < systemTime) && 
                                        <input 
                                            type="checkbox" 
                                            checked={selectedBids.length > 0 && this.checkTripAllBid(trip)}
                                            onClick={(e) => this.toggleTrip(e, trip)} 
                                        />}
                                        {valIndex + 1} <span className='theme-color curP fBold' onClick={() => {
                                        const { tripDetails } = this.state;
                                        if(tripDetails.includes(trip.id)) {
                                            tripDetails.splice(tripDetails.indexOf(trip.id), 1);
                                        } else {
                                            tripDetails.push(trip.id)
                                        }
                                        this.setState({ tripDetails })
                                    }}>{!tripDetails.includes(trip.id) ? '+' : '-'}</span></td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.zone}</td>
                                    {isDepotWise && <>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>{trip.from}</td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>{trip.depo_name}</td>
                                    </>}
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR(trip.total_price || trip.totalPrice)}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.contractTenureFrom && Moment(trip.contractTenureFrom).format('DD/MM/YYYY') || ''} - {trip.contractTenureTo && Moment(trip.contractTenureTo).format('DD/MM/YYYY') || ''}</td>
                                    {(maxBids || []).map((sbid, bidIndex) => {
                                        const bid = trip.bids[bidIndex] || {};
                                        return <td style={{ 'borderBottom': '1px solid grey'}} className="fs-14">
                                            <div>
                                                {(rfq.rfqDetails.biddingEnd < systemTime) && 
                                                    <input 
                                                        type="checkbox" 
                                                        checked={selectedBids.length > 0 && (selectedBids || []).find(sbid => sbid.id === bid.id)}
                                                        onClick={(e) => this.toggleBid(e, bid, trip)} 
                                                    />}
                                                {bid.transporterName}
                                            </div>
                                            <div className='fBold'>{formatToINR(bid.price || '')}</div>
                                            {bid.isSentLoiApprover && !isApproveOfLoi && <span className="header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5">LOI Sent for Approver</span>}
                                            {bid.isLoiSent && bid.isAccept !== false && bid.isAccept !== true && !isApproveMessage &&
                                                <span className={Classname("header-dark-color pr-2 pl-2 pt-2 pb-2 br-5", {
                                                    "bg-counter": !(bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= systemTime),
                                                    "bg-error": (bid.loiAcceptValidFrom && bid.loiAcceptValidTo <= systemTime)
                                                })}>
                                                    {
                                                        bid.loiAcceptValidTo <= systemTime
                                                        ?
                                                        <Fragment>LOI Ignored</Fragment>

                                                        :
                                                        <Fragment> LOI Sent </Fragment>
                                                    }
                                                </span>
                                            }
                                                {bid.isLoiSent && bid.isAccept === true && <span className="header-dark-color bg-accept pr-2 pl-2 pt-2 pb-2 br-5 mb-5">LOI Accepted</span>}
                                                {bid.isLoiSent && bid.isAccept === false && <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5 mb-5">LOI Rejected</span>}
                                                {bid.isLoiSent === false && bid.isAccept === false && <span className="header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5 mb-5">LOI Rejected</span>}

                                                <div>{bid.isLoiApproved && <span className="header-dark-color bg-approved pr-2 pl-2 pt-2 pb-2 br-5 mb-5">LOI Approved</span>}</div>
                                                <div>{isApproveOfLoi && <span className="header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5 mb-5">Approve LOI</span>} </div>
                                        </td>
                                    })}
                                </tr>
                                {tripDetails.includes(trip.id) && 
                                <tr>
                                    <td colSpan={(isDepotWise ? '6' : '4') + maxBids.length}>
                                    <table cellpadding="0" cellspacing="0" className="col-1 mb-20">
                                        <thead>
                                        <tr>
                                            {isDepotWise && <>
                                                <th style={{'backgroundColor': '#486aa3'}}>Zone</th>
                                                <th style={{'backgroundColor': '#486aa3'}}width="200">Depot Name</th>
                                            </>}
                                            <th style={{'backgroundColor': '#486aa3'}} width="250">Material Desc.</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="80">Product Type</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="50">Base Rate (Excluding GST)</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">Quantity</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">UOM</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="50">Total MSP</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">LSP</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">SSP</th>
                                            {((trip.sub_trip_disposal_product[0] || {}).bids || []).map(bid => <th style={{'backgroundColor': '#486aa3'}} width="250">{bid.order_text}</th>)}
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {(trip.sub_trip_disposal_product || []).map((subTrip, subTripIndex) => {
                                            return(<>
                                            <tr>
                                                {isDepotWise && <>
                                                    <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.zone}</td>
                                                    <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.depo_name}</td>
                                                </>
                                                }
                                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                                    {subTrip.material_code_description}
                                                    <span className='theme-color curP fBold fs-20 ml-10' onClick={() => {
                                                        const { subTripDetails } = this.state;
                                                        if(subTripDetails.includes((trip.id + subTripIndex))) {
                                                            subTripDetails.splice(subTripDetails.indexOf((trip.id + subTripIndex)), 1);
                                                        } else {
                                                            subTripDetails.push((trip.id + subTripIndex))
                                                        }
                                                        this.setState({ subTripDetails })
                                                    }}>{!subTripDetails.includes(trip.id + subTripIndex) ? '+' : '-'}</span>
                                                </td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.product_type}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR((subTrip.bidding_and_payments || {}).qbr)}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.quantity}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.pricing_basis_name}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR(subTrip.quantity_cost)}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{'-'}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{'-'}</td>
                                                {(subTrip.bids || []).map(bid => {
                                                    return <td style={{ 'borderBottom': '1px solid grey'}}>
                                                        <div>{bid.transporter_name}</div>
                                                        <div>{formatToINR(bid.price)} <span className='fBold theme-color ml-10'>{formatToINR(bid.bid_quantity_cost)}</span></div>
                                                    </td>
                                                })}
                                            </tr>
                                            {(subTrip.disposal_material_trip || []).length > 0 && subTripDetails.includes(trip.id + subTripIndex) && <tr>
                                                <td colSpan={(isDepotWise ? '11' : '9')} style={{'padding': '0px 20px 15px 20px'}}>
                                                    <table cellpadding="0" cellspacing="0" className="col-1 mb-5">
                                                        <thead>
                                                            <tr>
                                                                <th>Depot Code</th>
                                                                <th>Depot Name</th>
                                                                <th>Base Rate</th>
                                                                <th>Quantity</th>
                                                                <th>UOM</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(subTrip.disposal_material_trip || []).map((strip, sIndex) => (
                                                            <tr>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.depo_code}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.depo_name}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{formatToINR((strip.bidding_and_payments || {}).qbr)}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.quantity}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.pricing_basis_name}</td>
                                                            </tr>))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>}
                                            </>)})}
                                        </tbody>
                                    </table>
                                    </td>
                                </tr>
                                }
                            </>)})}
                        </tbody>
                    </table>
                </ResponsiveTable>
            </div>
        )
    }
}

export default DisposalProductSeekerBids;